import { isMainDish } from "~/assets/js/Helpers/items";
import { generateUuid } from "~/assets/js/Helpers/util";

const itemIsReusableBowl = (item) => {
    const { reusableBowlsId } = reactConfig;

    if (!reusableBowlsId) {
        return false;
    }

    return item?.product_id === reusableBowlsId;
};

export const applyOnlyReusableBowlsFilter = (item) => {
    return itemIsReusableBowl(item);
};

export const hasReusableBowls = (cartItems) => {
    const numberOfReusableBowlItems = cartItems?.filter(
        applyOnlyReusableBowlsFilter
    ).length;
    return Boolean(numberOfReusableBowlItems);
};
export const applyNoReusableBowlsFilter = (item) => !itemIsReusableBowl(item);

export const applyMenuItemFilter = (item) => item.category !== "MENU";

export const getReusableBowlsPrice = (cartItems) => {
    const reusableBowlproduct = cartItems?.find(applyOnlyReusableBowlsFilter);
    return reusableBowlproduct ? reusableBowlproduct.value_gross : 0;
};

export const getQuantityOfRequiredReusableBowls = (cartItems) => {
    const saladsAndBowlsQuantity = cartItems.reduce((total, item) => {
        return isMainDish(item) ? total + item.quantity : total;
    }, 0);
    return saladsAndBowlsQuantity;
};

export const findIndexOfReusableBowls = (cartItems) => {
    const { reusableBowlsId } = reactConfig;
    const bowlsInCartIndex = cartItems?.findIndex(
        (item) => item?.product_id === reusableBowlsId
    );
    // no reusable bowls found in cart
    if (bowlsInCartIndex < 0) {
        return false;
    }

    return bowlsInCartIndex;
};

/**
 * Full cart object
 * @param {Object} cart
 *
 * Returns an array of updated cart items
 */
export const upsertReusableBowlsToCart = (cart) => {
    const { reusableBowlsId } = reactConfig;

    const numberOfRequiredBowls = getQuantityOfRequiredReusableBowls(
        cart.items
    );

    // Remove all existing bowls
    let items = cart.items.filter(applyNoReusableBowlsFilter);

    // Add new if necesarry
    if (numberOfRequiredBowls > 0) {
        const reusableBowlsProduct = {
            uid: generateUuid(),
            product_id: reusableBowlsId,
            quantity: numberOfRequiredBowls,
        };

        items.push(reusableBowlsProduct);
    }

    return items;
};
